/* eslint-disable default-param-last */
import { HYDRATE } from 'next-redux-wrapper';
import merge from "deepmerge";

export const types = {
  SET_INIT_STATUS: 'RECOMENDATOR/SET_INIT_STATUS',
  SET_RECOMENDATOR_INFO: 'RECOMENDATOR/SET_INFO',
  SELECT_RECOMENDATOR: 'RECOMENDATOR/SELECT_RECOMENDATOR',
  RESET_SELECTED_TV: 'RECOMENDATOR/RESET_SELECTED_TV',
  SET_SELECTED_ITEMS: 'RECOMENDATOR/SET_SELECTED_ITEMS',
  RECOMEND_PACKAGES: 'RECOMENDATOR/RECOMEND_PACKAGES',
  SET_RECOMEND_PACKAGES_STATUS: 'RECOMENDATOR/SET_RECOMEND_PACKAGES_STATUS',
  SET_RECOMENDED_PACKAGES: 'RECOMENDATOR/SET_RECOMENDED_PACKAGES',
  RESET_RECOMENDED_PACKAGES: 'RECOMENDATOR/RESET_RECOMENDED_PACKAGES',
  FILTER_ITEMS: 'RECOMENDATOR/FILTER_ITEMS',
  SET_HYDRATETE_MOD: 'RECOMENDATOR/SET_HYDRATETE_MOD',
  /* nextjs */
  HYDRATE: 'MAIN/HYDRATE',
};

export const actions = {
  setInitStatus: (data) => ({ type: types.SET_INIT_STATUS, data }),
  setRecomendPackagesStatus: (data) => ({ type: types.SET_RECOMEND_PACKAGES_STATUS, data }),
  setRecomendatorInfo: (data) => ({ type: types.SET_RECOMENDATOR_INFO, data }),
  selectRecomendator: (data, removeSessionStorage) => ({
    type: types.SELECT_RECOMENDATOR,
    ...data,
    removeSessionStorage,
  }),
  setSelectedItems: (data) => ({ type: types.SET_SELECTED_ITEMS, ...data }),
  recomendPackages: (data, tvchanels, opVersus) => ({
    type: types.RECOMEND_PACKAGES,
    ...{ data, tvchanels, opVersus },
  }),
  setRecomendedPackages: (data) => ({ type: types.SET_RECOMENDED_PACKAGES, ...data }),
  resetRecomendPackagesStatus: (data) => ({ type: types.RESET_RECOMENDED_PACKAGES, data }),
  filterItems: (data) => ({ type: types.FILTER_ITEMS, ...data }),
  resetSelectedTv: (data) => ({ type: types.RESET_SELECTED_TV, ...data }),
  setHidratateMod: (data) => ({ type: types.SET_HYDRATETE_MOD, data }),
};

const initialState = {
  status: {
    init: null,
    recomendPackages: null,
  },
  data: null,
  selectedItems: {
    fiber: null,
    mobileLines: null,
    tvChannels: [],
  },
  recomendedPackages: null,
  hydratateMod: 'client',
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { recomendator } = action.payload;
      const nextState = merge(state, recomendator);
      return nextState;
      /* console.log('state', state)
      console.log('recomendator', recomendator)
      console.log('recomendator?.hydratateMod', recomendator?.hydratateMod)
      if(recomendator?.hydratateMod === 'server') {
        console.log('prevalece lo de servidor')
        return{
          ...state,
          ...recomendator,
        }
      } else {
        console.log('prevalece lo de clireente')
        return{
          ...recomendator,
          ...state,
        }
      } */
    }
    case types.SET_HYDRATETE_MOD: {
      const { data } = action;
      return {
        ...state,
        hydratateMod: data,
      }
    }
    case types.SET_RECOMENDATOR_INFO: {
      const { data } = action;
      return {
        ...state,
        data,
      }
    }
    case types.SET_INIT_STATUS: {
      const { data } = action;
      return {
        ...state,
        status: { ...state.status, init: data },
      }
    }
    case types.SET_RECOMEND_PACKAGES_STATUS: {
      const { data } = action;
      return {
        ...state,
        status: { ...state.status, recomendPackages: data },
      }
    }
    case types.SET_SELECTED_ITEMS: {
      const { data } = action;
      return {
        ...state,
        selectedItems: { ...data },
      }
    }
    case types.FILTER_ITEMS: {
      const { data } = action;
      return {
        ...state,
        data: {
          ...state.data,
          filters: {
            ...data,
          },
        },
      }
    }
    case types.SET_RECOMENDED_PACKAGES: {
      const { data } = action;
      return {
        ...state,
        recomendedPackages: { ...data },
      }
    }
    case types.RESET_SELECTED_TV: {
      return {
        ...state,
        selectedItems: { ...state.selectedItems, tvChannels: [] },
      }
    }
    case types.RESET_RECOMENDED_PACKAGES: {
      const { data } = action;
      const newData = state.data;
      console.log('entro y reseteo')
      if (newData && newData.filters) {
        const keys = Object.keys(newData.filters);
        if (keys && Array.isArray(keys) && keys.length > 0) {
          keys.forEach((eachKey) => {
            if (
              newData.filters[eachKey]
              && Array.isArray(newData.filters[eachKey])
              && newData.filters[eachKey].length > 0
            ) {
              newData.filters[eachKey].forEach((eachitem) => {
                eachitem.show = true;
              });
            }
          });
        }
      }
      if (action?.data?.filters) {
        return {
          ...state,
          data: newData,
          recomendedPackages: null,
          status: {
            ...state.status,
            recomendPackages: null,
          },
        };
      }
      return {
        ...state,
        data: newData,
        recomendedPackages: null,
        selectedItems: {
          fiber: null,
          mobileLines: null,
          tvChannels: [],
        },
        status: {
          ...state.status,
          recomendPackages: null,
        },
      };
    }
    default:
      return state;
  }
}

export default reducer;
